module.exports = __webpack_public_path__ + "img/woman_hug.d631280e.png";